export const saleRevenueData = [
    {
        title:"Sale",
        count:"654",
        svgIcon:"arrow-down",
        percentage:"- 36.28%",
        time:"Then last week",
        color:"secondary"
    },
    {
        title:"Revenue",
        count:"$45,680",
        svgIcon:"arrow-top",
        percentage:"+14.28%",
        time:"Since last month",
        color:"primary"
    },
    {
        title:"Conversion",
        count:"34%",
        svgIcon:"arrow-down",
        percentage:"- 36.28%",
        time:"Then last week",
        color:"secondary"
    },
    {
        title:"Leads",
        count:"654",
        svgIcon:"arrow-top",
        percentage:"+20.28%",
        time:"Since last 6 month",
        color:"primary"
    }
]